import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SavingsContextType {
  savedAmount: string;
  updateSavedAmount: (amount: string) => void;
}

const defaultContext: SavingsContextType = {
  savedAmount: '',
  updateSavedAmount: () => {},
};

const SavingsContext = createContext<SavingsContextType>(defaultContext);

export const useSavings = () => useContext(SavingsContext);

interface SavingsProviderProps {
  children: ReactNode;
}

export const SavingsProvider: React.FC<SavingsProviderProps> = ({ children }) => {
  const [savedAmount, setSavedAmount] = useState<string>('');

  const updateSavedAmount = (amount: string) => {
    setSavedAmount(amount);
  };

  return (
    <SavingsContext.Provider value={{ savedAmount, updateSavedAmount }}>
      {children}
    </SavingsContext.Provider>
  );
};